/** @jsxImportSource @emotion/react */
import { useEffect, useState } from 'react';
import { scale } from '../../util/scale';
import Flex from '../UI/Flex';
import Link from '../UI/Link';
import track from '../../lib/events';
import { isMobile } from '@wren/shared';

const topAnnouncement = (backgroundColor = 'white', color = '#333') =>
  scale({
    textAlign: 'left',
    backgroundColor: backgroundColor,
    color: color,
    position: 'relative',
    boxSizing: 'border-box',
    padding: '14px 8px',
  });

const primaryIconContainer = scale({
  paddingRight: 16,
  paddingLeft: [8, 8, 0, 0],
});

const closeButtonContainer = scale({
  position: 'absolute',
  right: 16,
  top: 16,
  cursor: 'pointer',
  fontWeight: 600,
});

const primaryIcon = (
  <svg
    css={scale({ height: [50, 68], width: [50, 68] })}
    viewBox="0 0 68 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="68"
      height="68"
      rx="21.5333"
      fill="#00836C"
      fill-opacity="0.1"
    />
    <path
      d="M51.6835 21.9764C51.6835 21.7817 51.6062 21.5949 51.4685 21.4572C51.3308 21.3195 51.144 21.2421 50.9492 21.2421H49.4182L48.1846 16.9758C48.6808 16.6809 49.0791 16.2464 49.3298 15.7264C49.5804 15.2065 49.6723 14.6242 49.594 14.0523C49.5156 13.4804 49.2705 12.9443 48.8893 12.5109C48.508 12.0775 48.0075 11.7661 47.4503 11.6155V10.7343C47.4503 10.5396 47.3729 10.3528 47.2352 10.2151C47.0975 10.0774 46.9108 10 46.716 10C46.5213 10 46.3345 10.0774 46.1968 10.2151C46.0591 10.3528 45.9817 10.5396 45.9817 10.7343V11.6155C45.4221 11.7613 44.918 12.0692 44.5326 12.5004C44.1472 12.9317 43.8977 13.4671 43.8153 14.0395C43.733 14.612 43.8215 15.196 44.0697 15.7183C44.3179 16.2407 44.7149 16.6781 45.2107 16.9758L43.9991 21.2458H42.4681C42.3716 21.2458 42.2762 21.2648 42.1871 21.3017C42.098 21.3386 42.017 21.3927 41.9489 21.4609C41.8807 21.5291 41.8266 21.61 41.7897 21.6991C41.7528 21.7882 41.7338 21.8837 41.7338 21.9801C41.7338 22.0765 41.7528 22.172 41.7897 22.2611C41.8266 22.3502 41.8807 22.4311 41.9489 22.4993C42.017 22.5675 42.098 22.6216 42.1871 22.6585C42.2762 22.6954 42.3716 22.7144 42.4681 22.7144H43.5695L41.6824 29.4186C41.6305 29.606 41.6551 29.8064 41.7508 29.9757C41.8464 30.145 42.0054 30.2695 42.1927 30.3217C42.3787 30.3753 42.5783 30.3533 42.7481 30.2605C42.9179 30.1676 43.0442 30.0115 43.0996 29.8261L45.1152 22.7217H48.2984L49.6532 27.4947L50.0864 29.0294L50.3141 29.8261C50.3401 29.9191 50.3842 30.0062 50.4439 30.0822C50.5035 30.1582 50.5776 30.2217 50.6618 30.2691C50.746 30.3165 50.8387 30.3468 50.9347 30.3584C51.0306 30.3699 51.1279 30.3625 51.2209 30.3364C51.314 30.3104 51.401 30.2663 51.477 30.2066C51.553 30.147 51.6165 30.0729 51.6639 29.9887C51.7113 29.9045 51.7416 29.8118 51.7532 29.7158C51.7648 29.6199 51.7573 29.5226 51.7313 29.4296L51.5807 28.9045L51.2393 27.6966L49.8294 22.7254H50.9309C51.0301 22.7279 51.1288 22.7103 51.221 22.6736C51.3132 22.6369 51.397 22.5818 51.4673 22.5118C51.5377 22.4418 51.5931 22.3583 51.6303 22.2663C51.6674 22.1743 51.6856 22.0756 51.6835 21.9764V21.9764ZM45.5338 21.2421L46.6352 17.3797H46.7931L47.8946 21.2421H45.5338ZM46.7087 15.9185C46.4182 15.9185 46.1343 15.8323 45.8927 15.671C45.6512 15.5096 45.463 15.2802 45.3519 15.0119C45.2407 14.7435 45.2116 14.4482 45.2683 14.1633C45.3249 13.8785 45.4648 13.6168 45.6702 13.4114C45.8756 13.206 46.1373 13.0661 46.4221 13.0095C46.707 12.9528 47.0023 12.9819 47.2707 13.093C47.539 13.2042 47.7684 13.3924 47.9298 13.6339C48.0911 13.8755 48.1773 14.1594 48.1773 14.4499C48.1773 14.8381 48.0235 15.2105 47.7497 15.4857C47.4759 15.7609 47.1042 15.9165 46.716 15.9185H46.7087Z"
      fill="#00836C"
    />
    <path
      d="M10.0705 40.0839C9.85777 41.2876 10.131 42.5267 10.8302 43.5294C11.5294 44.5321 12.5976 45.2167 13.8007 45.4332L32.3528 48.1832L34.8714 47.0817L14.0614 43.9903C13.2415 43.8419 12.5139 43.3743 12.0383 42.6902C11.5627 42.006 11.3779 41.1611 11.5244 40.3409C11.6247 39.9029 11.8241 39.4937 12.1074 39.1449C12.3906 38.7961 12.7501 38.5169 13.1582 38.3289C13.686 38.0698 14.2682 37.9412 14.856 37.954C15.4438 37.9668 16.02 38.1205 16.536 38.4023C16.6965 38.4835 16.8813 38.503 17.0553 38.4569C17.2292 38.4109 17.3802 38.3026 17.4796 38.1526L25.6083 25.9339L40.6027 27.8211L41.0065 26.3928L26.5225 24.5681L29.5441 20.0265C29.6512 19.8638 29.6893 19.6653 29.65 19.4746C29.6108 19.2839 29.4974 19.1166 29.3348 19.0095C29.2615 18.9688 29.1854 18.9332 29.1072 18.903C25.7404 17.662 23.0566 19.9604 22.1167 21.3592L10.8158 38.3032C10.5027 38.8676 10.2528 39.4647 10.0705 40.0839V40.0839Z"
      fill="#00836C"
    />
    <path
      d="M50.7214 40.0878L56.8969 29.4405C56.9588 29.3352 56.9934 29.2162 56.9977 29.0942C57.0021 28.9722 56.9759 28.851 56.9216 28.7416C56.8672 28.6323 56.7865 28.5382 56.6867 28.4679C56.5869 28.3976 56.4711 28.3533 56.3498 28.339L52.8252 27.8948L53.1483 29.0293C53.1846 29.1577 53.2092 29.2892 53.2217 29.4221L55.0575 29.6534L48.4341 41.0938L50.7214 40.0878Z"
      fill="#00836C"
    />
    <path
      d="M48.0634 27.2853L45.442 26.9548L45.0381 28.3794L48.4966 28.8163L48.0634 27.2853Z"
      fill="#00836C"
    />
    <path
      d="M31.0128 50.893C31.0196 51.0402 31.0705 51.1819 31.1589 51.2997C31.2473 51.4176 31.3691 51.5061 31.5085 51.5539L47.2188 56.9546C47.4019 57.0195 47.6032 57.0091 47.7786 56.9258C47.9541 56.8426 48.0894 56.6932 48.155 56.5104L53.453 41.8428C53.5016 41.7075 53.5094 41.5609 53.4754 41.4213C53.4415 41.2816 53.3673 41.155 53.2621 41.0571C53.1564 40.9588 53.0241 40.8939 52.8818 40.8704C52.7395 40.8469 52.5933 40.8659 52.4617 40.9249L31.4497 50.1917C31.3149 50.2513 31.2012 50.35 31.1233 50.4751C31.0454 50.6002 31.0069 50.7458 31.0128 50.893V50.893ZM40.0777 49.3987L47.5235 46.1164C47.6552 46.0573 47.8013 46.0384 47.9436 46.0619C48.086 46.0854 48.2182 46.1503 48.3239 46.2486C48.4291 46.3465 48.5033 46.4731 48.5373 46.6128C48.5712 46.7524 48.5634 46.899 48.5148 47.0343L46.635 52.2221C46.5694 52.4049 46.4341 52.5543 46.2586 52.6375C46.0832 52.7208 45.8819 52.7312 45.6988 52.6663L40.1328 50.7535C39.9944 50.7049 39.8737 50.6159 39.7863 50.4981C39.6989 50.3802 39.6488 50.2389 39.6425 50.0923C39.6362 49.9457 39.6739 49.8006 39.7508 49.6757C39.8277 49.5507 39.9403 49.4517 40.0741 49.3914L40.0777 49.3987Z"
      fill="#00836C"
    />
    <path
      d="M38.2964 31.2869L38.0804 30.9485L37.6558 30.9355C37.3885 30.9284 31.0808 30.7682 27.9925 33.4432C27.2188 34.1906 26.968 34.9688 26.8245 35.6328C26.4784 37.2342 27.3533 38.8652 28.5845 39.8409C27.7988 40.1784 27.0036 40.4205 26.2411 40.5187L26.5176 41.8181C30.6539 41.2828 35.4407 37.39 36.1955 33.953L36.2023 33.9458C35.0997 39.048 32.3956 41.1338 32.3956 41.1338C32.4011 41.1397 32.4056 41.1433 32.4103 41.149L31.7348 41.5537C32.4338 42.4585 33.3811 42.6766 33.777 42.7668C36.2246 43.2056 39.026 41.9939 39.7672 38.2963C40.1147 36.567 39.9098 33.8171 38.2964 31.2869Z"
      fill="#00836C"
    />
  </svg>
);

const closeIcon = (
  <svg
    css={scale({ height: [12, 14], width: [12, 14] })}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 1.91357L17.0864 0L9.5 7.58643L1.91357 0L0 1.91357L7.58643 9.5L0 17.0864L1.91357 19L9.5 11.4136L17.0864 19L19 17.0864L11.4136 9.5L19 1.91357Z"
      fill="#333333"
    />
  </svg>
);

const handleOnClick = () => {
  track('Server: User Clicked on Wren For Business Banner', {
    isMobile: isMobile(),
  });
};

export default function WrenForBusinessBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);

    // Cleanup function to clear the timeout if the component unmounts before the timeout finishes
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <Flex css={topAnnouncement()} align="center" justify="center">
      <div css={primaryIconContainer}>{primaryIcon}</div>
      <div>
        <p css={{ fontSize: 16, fontWeight: 600 }}>Wren for Business</p>
        <p css={{ fontSize: 14 }}>
          Designed to fill the gaps in your company’s net-zero goals.
        </p>
        <Link
          onClick={() => handleOnClick()}
          to="/business"
          css={{ textDecoration: 'none', fontWeight: 500 }}
        >
          <p css={{ fontSize: 14, fontWeight: 600 }}>Learn more →</p>{' '}
        </Link>
      </div>
      <div css={closeButtonContainer} onClick={() => setIsVisible(false)}>
        {closeIcon}
      </div>
    </Flex>
  );
}
